import Vue from 'vue'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

import 'vxe-table/lib/style.css'
// 导入主题变量，也可以重写主题变量
import 'vxe-table/styles/cssvar.scss'
import VxeTable from 'vxe-table'
Vue.use(VxeTable)

import 'vxe-pc-ui/es/style.css'
import VxeElement from 'vxe-pc-ui'
Vue.use(VxeElement)

zhLocale.el.pagination = {
 skip:'w',
 jump:'w2',
 goto: '跳至',
 pagesize: '条/页',
 total: `共计 {total} 条`,
 pageClassifier: '页',
};
Vue.use(Element,{  zhLocale })

